import _ from "lodash";

export const QUOTES = _.sample([
  {
    quote: "Success is not final; failure is not fatal: It is the courage to continue that counts.",
    author: "Winston S. Churchill"
  },
  {
    quote: "The road to success and the road to failure are almost exactly the same.",
    author: "Colin R. Davis"
  },
  {
    quote: "There are two types of people who will tell you that you cannot make a difference in this world: those who are afraid to try and those who are afraid you will succeed.",
    author: "Ray Goforth"
  },
  {
    quote: "Successful people do what unsuccessful people are not willing to do. Don't wish it were easier; wish you were better.",
    author: "Jim Rohn"
  },
  {
    quote: "I owe my success to having listened respectfully to the very best advice, and then going away and doing the exact opposite.",
    author: "G. K. Chesterton"
  },
  {
    quote: "The ones who are crazy enough to think they can change the world, are the ones that do.",
    author: "Anonymous"
  },
  {
    quote: "The only limit to our realization of tomorrow will be our doubts of today.",
    author: "Franklin D. Roosevelt"
  },
  {
    quote: "Character cannot be developed in ease and quiet. Only through experience of trial and suffering can the soul be strengthened, ambition inspired, and success achieved.",
    author: "Helen Keller"
  },

]);
